/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_Out_2Inputs */

const en_services_flow_out_2 = /** @type {(inputs: Services_Flow_Out_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account update`)
};

const lv_services_flow_out_2 = /** @type {(inputs: Services_Flow_Out_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienta ieraksta atjauninājums`)
};

/**
* | output |
* | --- |
* | "Account update" |
*
* @param {Services_Flow_Out_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_out_2 = /** @type {((inputs?: Services_Flow_Out_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_Out_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_out_2(inputs)
	return en_services_flow_out_2(inputs)
});